import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';
import { bindActionCreators } from 'redux';

import appConfigurationsActions from '../../redux/appConfigurations/actions';
import AppConfigurations from '../../components/AppConfigurations';
import SidebarContainer from '../SidebarContainer';
import './AppManagement.scss';

function AppManagement(props) {
  return (
    <SidebarContainer title="App Management">
      <div className="app-management-container">
        <AppConfigurations {...props} />
      </div>
    </SidebarContainer>
  );
}

AppManagement.propTypes = {
  appConfigurations: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = ({ appConfigurations }) => ({ appConfigurations });

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...appConfigurationsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppManagement);
